import { render } from "./Scheme.vue?vue&type=template&id=72ed453b&scoped=true"
import script from "./Scheme.vue?vue&type=script&lang=js"
export * from "./Scheme.vue?vue&type=script&lang=js"

import "./Scheme.vue?vue&type=style&index=0&id=72ed453b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72ed453b"]])

export default __exports__